<div>
    <div class="modal-header">
            <div class="col-md-10">
                <h5 class="modal-title text-start"><strong>Termos e condições</strong></h5>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn-close float-end" (click)="cancelar()" aria-label="Close"></button>
            </div>

    </div>
    <div class="modal-body">
        <div class="bn-form-group">
            <label for="termosTextArea">Termos e condições: </label>
            <br>
            <textarea class="form-control"
                    id="termosTextArea"
                    rows="10"
                    cols="90"
                    class="text-align-justify"
                    disabled> {{termos}}
            </textarea>
        </div>
        <div class="form-check">
            <input type="checkbox" class="form-check-input" id="checkCiencia" (change)="changeCheck($event)">
            <label class="form-check-label" for="checkCiencia">Declaro que estou ciente dos termos e condições aplicáveis</label>
        </div>
    </div>

    <div class="modal-footer">
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-default" (click)="cancelar()">Fechar</button>
                <button class="btn btn-primary" (click)="ok()"  [disabled]="!cienciaDosTermosConfirmada">Confirmar</button>
            </div>
        </div>
    </div>
</div>
